/** 对单金额展示：0 表示价格面谈 */
export function formatIssueOrderMoney(money) {
  const n = Number(money)
  if (Number.isNaN(n)) return '-'
  if (n === 0) return '价格面谈'
  return n.toFixed(2)
}



// WEBPACK FOOTER //
// ./src/utils/issueOrderFormat.js